export enum SecondaryFactor {
  EMAIL = 'email',
  SMS = 'sms',
  PUSH = 'push',
  RCS = 'rcs',
  WHATSAPP = 'whatsapp',
}

export * from './sca'
